module.exports = __webpack_public_path__ + "img/ui-browser-slider.4d42a940.svg";